import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";
import { HashLoader } from "react-spinners";
import Failuremessage from "./failuremessage.js"


export default function ReportData(){
    const [res,setRes] = useState();
    const [resTwo,setResTwo] = useState();
    const [loading,setLoading] = useState(false);
    const [loadingtwo,setLoadingtwo] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [formData,setFormData]=useState({
        email:"",
        name:"",
        mobileNumber:""
    })
    const rootUrl = "http://localhost:3000";
    const localrootUrl = "https://ahkserver.onrender.com";


    function formSubmit(event){
        setLoading(true);
        event.preventDefault();
        const fetchData = async ()=>{
            try{
                const data = new FormData();
                data.append('mrnumber',event.target[1].value);
                for(var i=0;i<selectedFile.length;i++){
                    data.append('reports', selectedFile[i]);
                }
                const dataposter = await axios.post(`${localrootUrl}/upload`,data);
            const response = dataposter.data;
            setRes(response);
            setLoading(false);
            console.log(data);
            }catch(error){
                console.log(error);
            }
        }
        fetchData();
        event.target[0].value = null;
        event.target[1].value=null;
    }

    function formTwoSubmit(event){
        setLoading(true);
        event.preventDefault();
        const fetchData = async ()=>{
            try{
                const dataposter = await axios.post(`${localrootUrl}/getSinglemrnumber`,formData,{withCredentials:true});
            const response = dataposter.data;
            if(response){
                setResTwo(response);
                setLoading(false);
            }
            }catch(error){
                console.log(error);
            }
        }
        fetchData();
        event.target[1].value=null;
        event.target[2].value=null;
        event.target[3].value=null;
    }


    return <div key={res} className="uploader">

       <form onSubmit={formSubmit} method="POST" enctype='multipart/form-data' className="former" style={{alignItems:"center"}}>
       <h2 className="updates">Upload Files of User</h2>
        <input onInput={e => setSelectedFile(e.target.files)} name='reports' className="inputtext custom" id="fileupload" type="file" multiple />
        <input type="text" className="inputtext custom" name="mrnumber" placeholder="MR number"/>
        <button className="submit" type="submit">Submit</button>
        {loading?<HashLoader size={50} className="newloader" loading={loading}/>:res?<Failuremessage isFail={res.success?false:true} successmessage={res.success} custommessage={res.failure}/>:null}
       </form>
       <form onSubmit={formTwoSubmit} method="POST" className="former" style={{alignItems:"center"}}>
       {loadingtwo?<HashLoader size={50} className="newloader" loading={loadingtwo}/>:resTwo?<Failuremessage isFail={resTwo.mrnumber?false:true} successmessage={"Mr Number is: "+resTwo.mrnumber} custommessage={resTwo.failure}/>:<h2 className="updates">Find MR Number of User</h2>}
        <input className="inputtext custom" type="text" name="email" placeholder="Enter Email" value={formData.email} onChange={(event)=>setFormData((prevVal)=>{return {...prevVal,email:event.target.value}})}/>
        <input className="inputtext custom" type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={(event)=>setFormData((prevVal)=>{return {...prevVal,name:event.target.value}})}/>
        <input className="inputtext custom" type="text" name="mobileNumber" placeholder="Enter Mobile Number" value={formData.mobileNumber} onChange={(event)=>setFormData((prevVal)=>{return {...prevVal,mobileNumber:event.target.value}})}/>
        <button className="submit" type="submit">Submit</button>
        <Link to="/seeAll" className="updates link" style={{color:"black",cursor:"pointer"}}>See All Data</Link>
       </form>
    </div>
}